import { ContentBox } from "@msuite/ui/content-box";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";
import { ArticleGroupsMenu } from "./article-groups-menu";
import { columns } from "./table-config";

export function ArticleGroups() {
	/** Query */
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["article-groups"],
		queryFn: async () => {
			const response = await client.stock["article-groups"].$get();
			const data = await responseHandler(response);
			return data.articleGroups;
		},
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={data}
				columns={columns}
				isLoading={isLoading}
				refetch={refetch}
				queryKey={queryKey}
				menu={<ArticleGroupsMenu />}
				persistenceKey="data-stock-article-groups-table"
			/>
		</ContentBox>
	);
}
